import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from './config';

// Kontrakt: apka zewnętrzna zapisuje dokument user_notifications/crossSection_{uid}
// i otwiera /browse?handoff=1. BoreholeBrowserPage czyta, aplikuje, kasuje.
//
// Używamy istniejącej kolekcji user_notifications zamiast tworzyć osobne rules.
// Dokument MUSI mieć pole `userEmail` zgodne z auth.currentUser.email — rules
// kolegi autoryzują delete/update właśnie po tym polu.
//
// Kształt dokumentu:
// {
//   userEmail: "user@example.com",       // WYMAGANE — autoryzacja w rules
//   type: "crossSectionHandoff",         // WYMAGANE — odróżnienie od zwykłych notyfikacji
//   crossSection: { name, skalaPozioma, skalaPionowa, ... },
//   items: [
//     { distance, currentProjectId, infoBoreholeId, userDataId, projectName, boreholeName, coordX, coordY, coordZ },
//     ...
//   ],
//   createdAt: serverTimestamp(),
//   source: 'nazwa-apki-zrodlowej'
// }

const handoffDocPath = (uid) => doc(db, 'user_notifications', `crossSection_${uid}`);

export const readPendingHandoff = async (uid) => {
  if (!uid) return null;
  const snap = await getDoc(handoffDocPath(uid));
  if (!snap.exists()) return null;
  const data = snap.data();
  // Ignoruj zwykłe notyfikacje które trafiłyby na to ID przypadkowo
  if (data.type !== 'crossSectionHandoff') return null;
  // Defense in depth (CPT_SSO_REACT spec §9.3) — uzupelnia regule create,
  // ktora juz wiaze docId z uid. Tu odrzucamy obce/smieciowe dokumenty.
  if (data.source !== 'giode-portal') {
    console.warn('Handoff odrzucony — niespodziewany source:', data.source);
    return null;
  }
  return data;
};

export const clearPendingHandoff = async (uid) => {
  if (!uid) return;
  await deleteDoc(handoffDocPath(uid));
};
